import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "my-office-asset-tab" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("批量确认")
const _hoisted_4 = { class: "d-flex justify-content--center" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 确认 ")
const _hoisted_7 = { class: "d-flex d-flex-row-reverse" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 确认资产 ")
const _hoisted_9 = { style: {"color":"var(--el-color-info-light-3)"} }
const _hoisted_10 = { class: "d-flex" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", null, " 上传资产图片： ", -1)
const _hoisted_12 = { class: "dialog-footer" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("上传并确认 ")

import {computed, onBeforeMount, reactive, ref, watch} from "vue";
import Api from "@/http/modules";
import tbMix from "@/global_mixin/tableMixin";
import dayjs from "dayjs";
import {ElMessage, ElMessageBox, UploadUserFile} from "element-plus";


export default /*#__PURE__*/_defineComponent({
  props: {
    type: null,
    typeIsMyManager: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  type: string,
  typeIsMyManager: boolean,
}



const {
  //创建
  "POST/office/asset/task/my_assets": taskMyAssetApi,
  "POST/office/asset/task/batch_confirm_assets": batchConfirmAssetApi,
  "POST/office/asset/task/confirm_asset": confirmAssetApi
} = Api
const {
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(taskMyAssetApi)
onBeforeMount(() => {
  fetchData({type: props.type,filterTask:true})
})
const selectInfo = reactive<{ list: any[] }>({
  list: []
})
const rowClass = (data: { row: any, rowIndex: number, }) => {
  if (needHighlight(data.row)) {
    return "bg-highlight"
  } else {
    return "no-bg-highlight"
  }
}
const canBatchConfirm = computed(() => {
  return selectInfo.list.length > 0
})
const canSelect = (row: any) => {
  if (props.typeIsMyManager) {
    //我管理的页面，有领用人的，不能勾选
    return !needHighlight(row) && !isConfirmed(row) && !row.ownerId
  } else {
    return !needHighlight(row) && !isConfirmed(row)
  }
}


const needHighlight = (row: any) => {
  return parseFloat(row.purchasingPrice.replace(",", "")) > parseFloat(row.categoryLimitPrice.replace(",", ""))
}
const isConfirmed = (row: any) => {
  return row.confirmStatus === 'CONFIRMED'
}
const confirmDialogInfo = reactive<{
  isShow: boolean,
  no: string | null,
  loading: boolean
  asset: any,
}>({
  isShow: false,
  no: null,
  loading: false,
  asset: null
})
const fileList = ref<any[]>()
const onExceed = (files: File[], uploadFiles: UploadUserFile[]) => {
  ElMessage.warning("请先删除已选择的图片")
}

const confirmOrShowConfirmDialog = (asset: any) => {
  fileList.value = []
  if (needHighlight(asset)) {
    confirmDialogInfo.asset = asset;
    confirmDialogInfo.no = asset.no;
    confirmDialogInfo.loading = false;
    confirmDialogInfo.isShow = true;
  } else {
    //直接调用接口确认
    ElMessageBox.confirm("确定要确认该资产吗",
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
      let formData = new FormData()
      formData.append("assetId", asset.id)
      formData.append("taskNo", asset.taskNo)

      return confirmAssetApi(formData)
    }).then(() => {
      fetchData({type: props.type})
      ElMessage.success('确认成功')
    }).finally(() => {
    })
  }


}
const confirmAsset = () => {
  if (!fileList.value || fileList.value.length < 1) {
    ElMessage.warning("请先选择资产图片")
    return
  }
  confirmDialogInfo.loading = true
  let formData = new FormData()
  formData.append("assetId", confirmDialogInfo.asset.id)
  formData.append("taskNo", confirmDialogInfo.asset.taskNo)
  formData.append('pic', fileList.value[0].raw)
  confirmAssetApi(formData).then((r: any) => {

    confirmDialogInfo.loading = false
    fetchData({type: props.type})
    confirmDialogInfo.isShow = false
  }).catch((e: any) => {
    confirmDialogInfo.loading = false
  })

}
const handleSelectionChange = (val: any[]) => {
  selectInfo.list = val
}

const batchConfirm = () => {
  ElMessageBox.confirm("确认要操作选择的资产吗",
      '提示',
      {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
    return batchConfirmAssetApi({
      assetIds: selectInfo.list.map(i => i.id),
      taskNo: selectInfo.list[0].taskNo
    })
  }).then(() => {
    ElMessage.success('成功')
    fetchData({type: props.type})
  }).finally(() => {
  })
}



return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        type: "primary",
        disabled: !_unref(canBatchConfirm),
        onClick: batchConfirm
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createElementVNode("div", null, [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        ref: "myOfficeAssetTbEle",
        border: "",
        class: "mt-15 myOfficeAssetTb",
        data: _unref(MI_tableData),
        stripe: "",
        "row-key": "id",
        "max-height": _unref(MI_height) - 100 + 'px',
        "row-class-name": rowClass,
        onSelectionChange: handleSelectionChange
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "selection",
            width: "55",
            fixed: "",
            selectable: canSelect
          }),
          _createVNode(_component_el_table_column, {
            label: "固定资产编号",
            prop: "no",
            "min-width": "210",
            fixed: ""
          }),
          _createVNode(_component_el_table_column, {
            label: "状态",
            prop: "confirmStatusDesc",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "所属团队",
            prop: "orgName",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "所属公司",
            prop: "companyName",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "资产名称",
            prop: "name",
            "min-width": "120",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "规格型号",
            prop: "spec",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "电脑设备ID",
            prop: "deviceId",
            "min-width": "140",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "资产类别",
            prop: "categoryName",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "单位",
            prop: "unit",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "领用日期",
            prop: "ownerDate",
            "min-width": "120",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "领用人",
            prop: "ownerName",
            "min-width": "160",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "资产变动单号",
            prop: "lastAssetChangeNo",
            "min-width": "210",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "使用状态",
            prop: "statusDesc",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "存放位置",
            prop: "place",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "管理员",
            prop: "managerName",
            "min-width": "160",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "采购日期",
            prop: "purchasingDate",
            "min-width": "120",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "采购人",
            prop: "purchasingUserName",
            "min-width": "160",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "采购价格",
            prop: "purchasingPrice",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "备注",
            prop: "note",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "操作",
            fixed: "right",
            width: "140"
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_4, [
                (props.typeIsMyManager&&row.ownerId)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5))
                  : (isConfirmed(row))
                    ? (_openBlock(), _createBlock(_component_el_link, {
                        key: 1,
                        type: "info"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_el_link, {
                        key: 2,
                        type: "primary",
                        onClick: ($event: any) => (confirmOrShowConfirmDialog(row))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(needHighlight(row) ? "上传并确认" : "确认"), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "max-height"])), [
        [_directive_loading, _unref(MI_identify)]
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_el_pagination, {
          disabled: _unref(MI_identify),
          background: "",
          small: "",
          total: _unref(MI_total),
          currentPage: _unref(page),
          "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
          "page-size": _unref(size),
          "onUpdate:page-size": _cache[1] || (_cache[1] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
          class: "mt-10",
          "page-sizes": [10, 30, 50, 100, 300, 1000],
          layout: "sizes, prev, pager, next, total, jumper",
          onCurrentChange: _unref(MI_pageChange),
          onSizeChange: _unref(MI_sizeChange)
        }, null, 8, ["disabled", "total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      class: "confirmAssetDialog",
      modelValue: _unref(confirmDialogInfo).isShow,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(confirmDialogInfo).isShow) = $event)),
      draggable: "",
      width: "600px"
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", null, [
          _hoisted_8,
          _createElementVNode("span", _hoisted_9, "资产编号：" + _toDisplayString(_unref(confirmDialogInfo).no), 1)
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_el_button, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(confirmDialogInfo).isShow=false))
          }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            loading: _unref(confirmDialogInfo).loading,
            disabled: _unref(confirmDialogInfo).loading,
            onClick: confirmAsset
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }, 8, ["loading", "disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_component_el_upload, {
            "file-list": fileList.value,
            "onUpdate:file-list": _cache[2] || (_cache[2] = ($event: any) => ((fileList).value = $event)),
            class: "avatar-uploader",
            "auto-upload": false,
            multiple: false,
            limit: 1,
            "on-exceed": onExceed,
            "list-type": "picture",
            accept: "image/png, image/jpeg,image/jpg"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, { class: "avatar-uploader-icon" }, {
                default: _withCtx(() => [
                  _createVNode(_component_Plus)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["file-list"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})